import React from 'react';
import { autoId } from '@workday/upc-common';
import './unauthenticated-header.scss';
import { WdayLogo } from '../index';

export const ID_UNAUTHENTICATED_HEADER = 'unauthenticated-header';

export const UnauthenticatedHeader = () => {
    return (
        <header {...autoId(ID_UNAUTHENTICATED_HEADER)} className='unauthenticatedHeader'>
            <WdayLogo />
        </header>
    );
};
